import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkBrandExists, isNppBrand, nppDomain } from '../../configurations/Brands';
import NotFound from '../dynamicPages/NotFound';

function RouteOne({ match: { params: { brand } } }) {
  const normalizedBrand = brand.toLowerCase();

  if (isNppBrand(normalizedBrand)) {
    window.location.href = `${nppDomain()}/${normalizedBrand}`;
    return null;
  }

  if (checkBrandExists(normalizedBrand)) {
    return <Redirect to={`/${normalizedBrand}/en/categories`} />;
  }

  return <NotFound />;
}

export default RouteOne;
